import { XmlIcon } from './XmlIcon';

/**
 * author: Austin Andrews
 * id 994C18D8-DAF1-4311-A30B-CD93F5ADC233
 * name xml
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/xml.svg
 * tags
 * - Developer / Languages 
 */
export const CodeIcon = XmlIcon;
export default CodeIcon